module.exports = "pegasus/assets/frame-linkedin.png";